import React, { useState, useEffect } from 'react';
import CookieConsentBanner from './CookieConsentBanner';
import ConsentPreferencesModal from './ConsentPreferencesModal';
import { initializeAnalytics } from '../utils/consentAwareAnalytics';

/**
 * Cookie Consent Manager
 * Manages the cookie consent banner, modal, and analytics initialization
 * Drop this component into your App to enable full consent management
 */
const CookieConsentManager = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Initialize analytics with consent checking
    initializeAnalytics();

    // Listen for global cookie settings trigger
    const handleOpenSettings = (e) => {
      e.preventDefault();
      setIsModalOpen(true);
    };

    // Allow global access to open cookie settings
    window.openCookieSettings = () => setIsModalOpen(true);

    // Listen for custom events (e.g., from footer links)
    window.addEventListener('openCookieSettings', handleOpenSettings);

    return () => {
      window.removeEventListener('openCookieSettings', handleOpenSettings);
      delete window.openCookieSettings;
    };
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <CookieConsentBanner onOpenPreferences={handleOpenModal} />
      <ConsentPreferencesModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default CookieConsentManager;
